import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import styles from './StructuredList.module.scss';

export type StructuredListProps = {
  listType?: 'ol' | 'ul';
} & React.HTMLAttributes<HTMLUListElement>;

export const StructuredList = ({
  listType = 'ul',
  children,
  className,
  ...props
}: PropsWithChildren<StructuredListProps>) => {
  const ListWrapperElement = listType;

  return (
    <ListWrapperElement
      className={classNames(styles.list, className)}
      {...props}
    >
      {children}
    </ListWrapperElement>
  );
};
